import type { ReactNode, ComponentProps } from 'react'
import type { AppLinkProps } from '@/hooks/usePathHelper'
import {
  AdminHeaderActionButton,
  AdminPageHeader,
  AdminPageShell,
} from '@/components/patterns/admin-page'
import { Card } from '@/components/ui/card'
import { Link } from '@tanstack/react-router'
import { ArrowLeft, History } from 'lucide-react'
import { AuditHistory } from './AuditHistory'

export function RecordHistoryPage({
  backLabel,
  backLink,
  description,
  organizationId,
  recordId,
  recordLabel,
  subject,
}: ComponentProps<typeof AuditHistory> & {
  backLabel: string
  backLink: AppLinkProps
  description?: ReactNode
  recordLabel: string
}) {
  return (
    <AdminPageShell maxWidth="content">
      <AdminPageHeader
        icon={History}
        eyebrow="Record activity"
        title={`${recordLabel} history`}
        description={description}
        actions={
          <AdminHeaderActionButton variant="outline" asChild>
            <Link {...backLink}>
              <ArrowLeft className="size-4" />
              Back to {backLabel}
            </Link>
          </AdminHeaderActionButton>
        }
      />
      <Card className="gap-0 overflow-hidden py-0">
        <AuditHistory subject={subject} recordId={recordId} organizationId={organizationId} />
      </Card>
    </AdminPageShell>
  )
}
